export const generateTraceId = () => {
  return randomHexString(32)
}

export const randomHexString = (length: number) => {
  const hexChars = '0123456789abcdef'
  let result = ''

  for (let i = 0; i < length; i++) {
    // @SAST-ACCEPTED-RISK
    result += hexChars[Math.floor(Math.random() * 16)]
  }

  return result
}
